import React, { useState } from "react";
import { startCheckout } from "../lib/stripe";

const PLANS = [
  { id: "starter", label: "Starter", price: "$29", desc: "2 users · 500 contacts", features: ["Up to 2 team members", "500 contacts", "Unlimited deals & tasks", "Pipeline & activity log", "Email support"] },
  { id: "pro",     label: "Pro",     price: "$99", desc: "Unlimited everything", features: ["Unlimited team members", "Unlimited contacts", "CSV import & export", "Pipeline & activity log", "Priority support"], popular: true },
];

export function PlanGate({ org, user, onSignOut }) {
  const [loading, setLoading] = useState(null);
  const [error, setError]     = useState("");

  async function choose(plan) {
    setError(""); setLoading(plan);
    try {
      await startCheckout({ plan, orgId: org?.id, orgName: org?.name, email: user?.email, mode: "trial_signup" });
    } catch (err) {
      setError(err.message);
      setLoading(null);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", background: "var(--bg)", fontFamily: "var(--font)" }}>
      {/* Left panel */}
      <div style={{ width: 380, background: "#0C1929", display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "3rem 2.5rem", flexShrink: 0 }} className="hide-mobile">
        <div style={{ fontSize: 18, fontWeight: 700, color: "#fff", letterSpacing: "-0.3px" }}>
          Apex <span style={{ color: "#378ADD", fontWeight: 400 }}>CRM</span>
        </div>
        <div>
          <div style={{ fontSize: 24, fontWeight: 700, color: "#fff", lineHeight: 1.3, letterSpacing: "-0.5px", marginBottom: 14 }}>
            One last step<br/>before you're in.
          </div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", lineHeight: 1.7 }}>
            Pick a plan and add a card to activate your 5-day free trial of <strong style={{ color: "#fff" }}>{org?.name || "your workspace"}</strong>. You won't be charged a cent until the trial ends, and you can cancel anytime before then.
          </div>
        </div>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)" }}>© {new Date().getFullYear()} Apex CRM</div>
      </div>

      {/* Right panel */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
        <div style={{ width: "100%", maxWidth: 520 }}>
          <div style={{ marginBottom: "1.5rem" }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.4px", marginBottom: 6 }}>Choose your plan</div>
            <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Your 5-day trial starts as soon as you add a card — no charge until it ends.</div>
          </div>

          {error && (
            <div style={{ fontSize: 12, color: "#A32D2D", background: "#FCEBEB", border: "0.5px solid #F09595", borderRadius: 7, padding: "8px 12px", marginBottom: 16 }}>{error}</div>
          )}

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: "1.5rem" }}>
            {PLANS.map(plan => (
              <div key={plan.id} style={{ background: plan.popular ? "rgba(24,95,165,0.06)" : "var(--surface)", border: plan.popular ? "1.5px solid #185FA5" : "0.5px solid var(--border)", borderRadius: 12, padding: "1.25rem", position: "relative" }}>
                {plan.popular && (
                  <div style={{ position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", background: "#185FA5", color: "#fff", fontSize: 10, fontWeight: 600, padding: "2px 12px", borderRadius: 20, whiteSpace: "nowrap" }}>Most popular</div>
                )}
                <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>{plan.label}</div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 2, marginBottom: 2 }}>
                  <span style={{ fontSize: 30, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.8px" }}>{plan.price}</span>
                  <span style={{ fontSize: 12, color: "var(--text-muted)" }}>/month</span>
                </div>
                <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 12 }}>{plan.desc}</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14 }}>
                  {plan.features.map(f => (
                    <div key={f} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--text-muted)" }}>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l2.5 2.5L10 3.5" stroke="#639922" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                      {f}
                    </div>
                  ))}
                </div>
                <button
                  disabled={!!loading}
                  onClick={() => choose(plan.id)}
                  style={{ width: "100%", padding: "8px", fontSize: 13, fontWeight: 600, background: plan.popular ? "#185FA5" : "transparent", color: plan.popular ? "#fff" : "var(--text)", border: plan.popular ? "none" : "0.5px solid var(--border-strong)", borderRadius: 8, cursor: loading ? "not-allowed" : "pointer", fontFamily: "inherit", opacity: loading && loading !== plan.id ? 0.5 : 1 }}
                >
                  {loading === plan.id ? "Redirecting..." : `Continue with ${plan.label} →`}
                </button>
              </div>
            ))}
          </div>

          <div style={{ fontSize: 11, color: "var(--text-muted)", textAlign: "center", lineHeight: 1.6 }}>
            You'll be taken to Stripe to add a card securely. Nothing is charged today.
          </div>

          <div style={{ marginTop: "1.5rem", textAlign: "center" }}>
            <button onClick={onSignOut} style={{ background: "none", border: "none", color: "var(--text-muted)", cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>Sign out</button>
          </div>
        </div>
      </div>
    </div>
  );
}
